import React from 'react'
import Header from '../Components/Header/Header.js'
import ProductDetail from '../Components/ProductDetails/ProductDetail.js'

function ProductDetailPage() {
  return (
    <div>
        <Header/>
        <ProductDetail/>
    </div>
  )
}

export default ProductDetailPage